function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "di1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 11 3 L 247 3 L 247 145 L 11 145 Z M 11 3 "
})));

function SvgDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "26px",
    viewBox: "0 0 247.5 149.999998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "downicon1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#di1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,70.588684%,62.348938%)",
      fillOpacity: 1
    },
    d: "M 129.480469 90.136719 L 49.476562 9.976562 C 40.808594 1.292969 26.738281 1.292969 18.070312 9.976562 C 9.402344 18.664062 9.402344 32.761719 18.070312 41.445312 L 114.675781 138.238281 C 122.863281 146.441406 136.117188 146.441406 144.28125 138.238281 L 240.886719 41.445312 C 249.554688 32.761719 249.554688 18.664062 240.886719 9.976562 C 232.21875 1.292969 218.148438 1.292969 209.480469 9.976562 Z M 129.480469 90.136719 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/DownIcon.a97d5039.svg";
export { ForwardRef as ReactComponent };